'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getArrayMemberKey = function getArrayMemberKey() {
  var memberFieldKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var index = arguments[1];
  return memberFieldKey.replace(/\[\]/, '[' + index + ']');
};

exports.default = getArrayMemberKey;


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-metadata-2/dist/getArrayMemberKey.js
// module id = 287
// module chunks = 0